import { envParameters } from '@/lib/utils/constants';

import { isBrowser } from './config';
import { getServerStampedHeaders } from './server';

export const env = {
  apiBaseUrl: envParameters.baseApiUrl as string,
  superTokensApiUrl: envParameters.superTokensApiUrl as string,
  frontendUrl:
    (envParameters.webUrl as string) ??
    process.env.NEXT_PUBLIC_FRONTEND_URL ??
    '',
};

/**
 * Origin is used by some backends for CSRF / auditing.
 * - Browser: window.location.origin
 * - Server: derived from forwarded headers where possible, else env fallback
 */
export const getOrigin = async (): Promise<string> => {
  if (isBrowser()) {
    return window.location.origin ?? env.frontendUrl;
  }

  const stamped = await getServerStampedHeaders();
  return stamped.origin ?? env.frontendUrl;
};

export const getBrowserSessionId = (): string | undefined => {
  if (!isBrowser()) return undefined;
  return window.sessionStorage.getItem('session_id') || undefined;
};
